/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { crearTienda } from '../../store/actions';
import { Regex, Validate, RegexExtra, Config } from '../../other';
import { Grid, withStyles } from '@material-ui/core';
import {
  PublicLayout,
  InputUI,
  ButtonUI,
  AlertUI,
  CardModuleUI,
  SelectUI,
  ToggleUI,
  CheckboxUI,
} from '../common';
import { createAmplitudeEventWithDevice, amplitude_events } from '../amplitude';
import { TyCMessage } from './TyCMessage';

class CrearTienda_ extends Component {
  recaptchaRef = React.createRef();

  state = {
    crear_tienda: {
      t_nombre_completo: {
        auth: true,
        validate: false,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Nombre completo',
        id: 't_nombre_completo',
        name: 't_nombre_completo',
        change_param: 'crear_tienda',
        regex: Regex.NOMBRE_5_90,
        value: '',
        default_value: '',
        placeholder: 'Nombre y apellido',
        messages: {
          error: 'Ingresa entre 5 y 90 caracteres',
          error_extra: RegexExtra.NOMBRE_5_90,
        },
      },
      t_nombre: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Nombre de tu marca',
        id: 't_nombre',
        name: 't_nombre',
        change_param: 'crear_tienda',
        regex: Regex.NOMBRE_TIENDA,
        value: '',
        default_value: '',
        placeholder: 'Mi marca',
        messages: {
          error: 'Por favor, ingrese un nombre de marca válido',
          error_extra: RegexExtra.NOMBRE_TIENDA,
        },
      },
      t_email: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'email',
        label: 'Email',
        id: 't_email',
        name: 't_email',
        change_param: 'crear_tienda',
        regex: Regex.EMAIL,
        value: '',
        default_value: '',
        placeholder: 'algo@algo.com',
        messages: {
          error: 'Por favor, ingrese un email válido',
          error_extra: RegexExtra.EMAIL,
        },
      },
      t_tipo_documento: {
        validate: false,
        required: true,
        error: false,
        label: 'Tipo de documento',
        id: 't_tipo_documento',
        name: 't_tipo_documento',
        change_param: 'crear_tienda',
        value: 0,
        messages: {
          error: '',
        },
      },
      t_numero_documento: {
        auth: true,
        validate: false,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Número de identidad',
        id: 't_numero_documento',
        name: 't_numero_documento',
        change_param: 'crear_tienda',
        regex: Regex.DOCUMENTO_COLOMBIA,
        value: '',
        default_value: '',
        placeholder: '1234567',
        messages: {
          error: RegexExtra.DOCUMENTO_COLOMBIA,
          error_extra: '',
          help: RegexExtra.DOCUMENTO_COLOMBIA,
        },
      },
      t_clave: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'password',
        label: 'Clave',
        id: 't_clave',
        name: 't_clave',
        change_param: 'crear_tienda',
        regex: Regex.CLAVE,
        value: '',
        default_value: '',
        placeholder: '******',
        messages: {
          error: 'Por favor, ingrese una clave válida',
          error_extra: RegexExtra.CLAVE,
        },
      },
      t_tyc: {
        validate: false,
        name: 't_tyc',
        label: '',
        value: 0,
        change_param: 'crear_tienda',
      },
    },
    selects: {
      tipo_documento: [
        {
          label: 'CC',
          value: 0,
        },
        {
          label: 'CE',
          value: 1,
        },
        /*         {
          label: 'PPT',
          value: 2,
        }, */
      ],
    },
    forms: {
      crear_tienda: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    const idCountry = this.props.idCountry || 'ARG';

    if (idCountry === 'COL') {
      this.setState({
        crear_tienda: {
          ...this.state.crear_tienda,
          t_nombre: {
            ...this.state.crear_tienda.t_nombre,
            messages: {
              ...this.state.crear_tienda.t_nombre.messages,
              error: this.state.crear_tienda.t_nombre.messages.error.replace(
                'ingrese',
                'ingresa'
              ),
            },
          },
          t_email: {
            ...this.state.crear_tienda.t_email,
            messages: {
              ...this.state.crear_tienda.t_email.messages,
              error: this.state.crear_tienda.t_email.messages.error.replace(
                'ingrese',
                'ingresa'
              ),
            },
          },
          t_clave: {
            ...this.state.crear_tienda.t_clave,
            messages: {
              ...this.state.crear_tienda.t_clave.messages,
              error: this.state.crear_tienda.t_clave.messages.error.replace(
                'ingrese',
                'ingresa'
              ),
            },
          },
        },
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const idCountry = this.props.idCountry;
      const urlLandingPage = `${Config.LANDINGPAGE_URL}${
        idCountry === 'COL' ? '/co' : ''
      }`;

      this.renderCheckboxTyC(this.props.classes, urlLandingPage, idCountry);
    }
  }

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleChangeCheckbox = (e, aditional) => {
    let name = e.target.name;

    this.setState({
      [aditional]: {
        ...this.state[aditional],
        [name]: {
          ...this.state[aditional][name],
          value: this.state[aditional][name]['value'] ? 0 : 1,
        },
      },
    });
  };

  handleChangeSelect = ({ target }) => {
    const value = Validate.trim_int(target.value);
    const valueNumeroDocumento =
      this.state.crear_tienda.t_numero_documento.value;
    const typeDocument = this.state.selects.tipo_documento[value].label;

    this.setState(
      {
        crear_tienda: {
          ...this.state.crear_tienda,
          t_tipo_documento: {
            ...this.state.crear_tienda.t_tipo_documento,
            value: value,
          },
          t_numero_documento: {
            ...this.state.crear_tienda.t_numero_documento,
            regex:
              typeDocument === 'PPT'
                ? Regex.DOCUMENTO_COLOMBIA_PPT
                : Regex.DOCUMENTO_COLOMBIA,
            messages: {
              ...this.state.crear_tienda.t_numero_documento.messages,
              error:
                typeDocument === 'PPT'
                  ? RegexExtra.DOCUMENTO_COLOMBIA_PPT
                  : RegexExtra.DOCUMENTO_COLOMBIA,
              help:
                typeDocument === 'PPT'
                  ? RegexExtra.DOCUMENTO_COLOMBIA_PPT
                  : RegexExtra.DOCUMENTO_COLOMBIA,
            },
          },
        },
      },
      () => {
        this.handleChange(
          {
            target: { value: valueNumeroDocumento, name: 't_numero_documento' },
          },
          true,
          'crear_tienda'
        );
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let t_captcha = this.recaptchaRef.current.getValue();

    if (
      this.state.crear_tienda.t_tyc.value === 0 &&
      this.props.idCountry === 'COL'
    ) {
      this.setState({
        forms: {
          ...this.state.forms,
          crear_tienda: false,
        },
        alert: {
          open: true,
          type: 'error',
          message: 'Debes aceptar los términos y condiciones para continuar.',
        },
      });

      return;
    }

    this.setState(
      {
        forms: {
          ...this.state.forms,
          crear_tienda: true,
        },
      },
      () => {
        if (t_captcha) {
          let form = this.state.crear_tienda;

          let ca_codigo = this.props.match.params.ca_codigo
            ? this.props.match.params.ca_codigo
            : '';

          const idCountry = this.props.idCountry || 'ARG';

          let dataStore = {
            t_nombre: form.t_nombre.value,
            t_email: form.t_email.value,
            t_clave: form.t_clave.value,
            ca_codigo: ca_codigo,
            t_captcha: t_captcha,
            idCountry: idCountry,
          };

          let selectDocument = '';

          if (idCountry === 'COL') {
            selectDocument =
              this.state.selects.tipo_documento[form.t_tipo_documento.value]
                .label;

            dataStore = {
              ...dataStore,
              t_nombre_completo: form.t_nombre_completo.value,
              t_tipo_documento: selectDocument,
              t_numero_documento: form.t_numero_documento.value,
            };
          }

          if (Validate.validar_formulario(form)) {
            this.props.crearTienda(dataStore, (err, resp) => {
              if (err) {
                this.setState(
                  {
                    forms: {
                      ...this.state.forms,
                      crear_tienda: false,
                    },
                    alert: {
                      ...this.state.alert,
                      open: true,
                      message: resp.message,
                    },
                  },
                  () => {
                    createAmplitudeEventWithDevice(
                      amplitude_events.crear_tienda_failed.event_name,
                      amplitude_events.crear_tienda_failed.event_params
                    );
                    this.resetRecaptcha();
                  }
                );
              } else {
                if (typeof window !== 'undefined') {
                  if (window.fbq) {
                    window.fbq('track', 'StartTrial');
                  }
                  if (window.gtag) {
                    window.gtag('event', 'conversion', {
                      event_category: 'Crear Tienda',
                      event_label: 'Tienda Creada',
                    });
                  }
                }
              }
            });
          } else {
            Validate.validar_formulario_actualizar_obj(form, (new_form) => {
              this.setState(
                {
                  forms: {
                    ...this.state.forms,
                    crear_tienda: false,
                  },
                  crear_tienda: new_form,
                },
                () => {
                  createAmplitudeEventWithDevice(
                    amplitude_events.crear_tienda_failed.event_name,
                    amplitude_events.crear_tienda_failed.event_params
                  );
                  this.resetRecaptcha();
                }
              );
            });
          }
        } else {
          this.setState(
            {
              forms: {
                ...this.state.forms,
                crear_tienda: false,
              },
              alert: {
                open: true,
                type: 'error',
                message: 'Por favor, complete el captcha "No soy un robot"',
              },
            },
            () => {
              createAmplitudeEventWithDevice(
                amplitude_events.crear_tienda_failed.event_name,
                amplitude_events.crear_tienda_failed.event_params
              );
              this.resetRecaptcha();
            }
          );
        }
      }
    );
  };

  renderCheckboxTyC = (classes, urlLandingPage, idCountry) => {
    this.setState({
      crear_tienda: {
        ...this.state.crear_tienda,
        t_tyc: {
          ...this.state.crear_tienda.t_tyc,
          label: (
            <TyCMessage
              classes={classes}
              urlLandingPage={urlLandingPage}
              idCountry={idCountry}
            />
          ),
        },
      },
    });
  };

  resetRecaptcha = () => this.recaptchaRef.current.reset();

  render() {
    const { classes, idCountry } = this.props;

    const urlLandingPage = `${Config.LANDINGPAGE_URL}${
      idCountry === 'COL' ? '/co' : ''
    }`;

    return (
      <PublicLayout>
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <form onSubmit={this.handleSubmit}>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <CardModuleUI big_shadow>
                <div className={classes.card_padding}>
                  <div className={classes.logo_wrapper}>
                    <Link
                      to={
                        idCountry === 'COL' ? '/login?idCountry=COL' : '/login'
                      }
                    >
                      <img
                        src="https://dk0k1i3js6c49.cloudfront.net/landingpage/images/v4/empretienda-green-logo.png"
                        alt="Empretienda logo"
                        className={classes.logo}
                      />
                    </Link>
                  </div>
                  <ToggleUI show={idCountry === 'COL'}>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.crear_tienda.t_nombre_completo}
                    />
                  </ToggleUI>
                  <div className={classes.separator}></div>
                  <InputUI
                    handleChange={this.handleChange}
                    input={this.state.crear_tienda.t_nombre}
                  />
                  <div className={classes.separator}></div>
                  <InputUI
                    handleChange={this.handleChange}
                    input={this.state.crear_tienda.t_email}
                  />
                  <div className={classes.separator}></div>
                  <ToggleUI show={idCountry === 'COL'}>
                    <Grid container spacing={24}>
                      <Grid item xs={12} md={6}>
                        <SelectUI
                          data={this.state.crear_tienda.t_tipo_documento}
                          options={this.state.selects.tipo_documento}
                          handleChangeSelect={this.handleChangeSelect}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InputUI
                          handleChange={this.handleChange}
                          input={this.state.crear_tienda.t_numero_documento}
                        />
                      </Grid>
                    </Grid>
                    <div className={classes.separator}></div>
                  </ToggleUI>
                  <InputUI
                    handleChange={this.handleChange}
                    input={this.state.crear_tienda.t_clave}
                  />
                  <div className={classes.separator}></div>
                  <ReCAPTCHA
                    ref={this.recaptchaRef}
                    sitekey={Config.RECAPTCHA_PUBLIC_KEY}
                    onExpired={() => this.resetRecaptcha()}
                    onErrored={() => this.resetRecaptcha()}
                  />
                  <div className={classes.separator}></div>
                  <ToggleUI show={idCountry === 'COL'}>
                    <CheckboxUI
                      handleChangeCheckbox={this.handleChangeCheckbox}
                      checkbox={this.state.crear_tienda.t_tyc}
                    />
                  </ToggleUI>
                  <ButtonUI
                    type="submit"
                    label="Crear mi tienda"
                    size="large"
                    border_radius
                    fullWidth={false}
                    isLoading={this.state.forms.crear_tienda}
                  />
                  <ToggleUI show={idCountry !== 'COL'}>
                    <TyCMessage
                      classes={classes}
                      urlLandingPage={urlLandingPage}
                      idCountry={idCountry}
                    />
                  </ToggleUI>
                  <div className={classes.separator}></div>
                </div>
              </CardModuleUI>
            </Grid>
            <Grid item xs={12}>
              <p className={classes.link_left}>
                ¿Ya tenés tu tienda?{' '}
                <Link
                  to={idCountry === 'COL' ? '/login?idCountry=COL' : '/login'}
                  className={classes.link}
                >
                  Ingresar
                </Link>
              </p>
              <div className={classes.separator_mobile}></div>
            </Grid>
          </Grid>
        </form>
      </PublicLayout>
    );
  }
}

const styles = (theme) => ({
  separator: {
    width: '100%',
    height: '15px',
  },
  separator_mobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '50px',
    },
  },
  link_left: {
    color: '#666',
    fontFamily: 'Roboto',
    lineHeight: '1',
    textAlign: 'center',
    fontSize: '0.9rem',
    marginTop: '5px',
    marginBottom: '20px',
    padding: '0',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px',
      textAlign: 'left',
    },
  },
  link_below_left: {
    color: '#666',
    fontFamily: 'Roboto',
    lineHeight: '1',
    textAlign: 'center',
    fontSize: '0.9rem',
    marginTop: '10px',
    marginBottom: '20px',
    padding: '0',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px',
      textAlign: 'left',
    },
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  card_padding: {
    padding: '10px',
    [theme.breakpoints.up('sm')]: {
      padding: '10px 30px',
    },
  },
  logo_wrapper: {
    marginBottom: '30px',
  },
  logo: {
    width: '250px',
    maxWidth: '100%',
  },
  tos_text: {
    color: '#666',
    lineHeight: '1.3',
    fontSize: '0.8rem',
  },
  tos_text_link: {
    color: '#666',
    textDecoration: 'underline !important',
  },
});

const mapStateToProps = () => {
  const searchParams = new URLSearchParams(document.location.search);
  return {
    idCountry: searchParams.get('idCountry'),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    crearTienda: (data, callback) => dispatch(crearTienda(data, callback)),
  };
};

export const CrearTienda = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(CrearTienda_)
);
